import { render, staticRenderFns } from "./ShopDetailTable.vue?vue&type=template&id=d77a1ecc&scoped=true"
import script from "./ShopDetailTable.vue?vue&type=script&lang=js"
export * from "./ShopDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ShopDetailTable.vue?vue&type=style&index=0&id=d77a1ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77a1ecc",
  null
  
)

export default component.exports